import React from "react";
import * as S from "./styles";

export const Slide1: React.FC = () => {
  return (
    <S.Container>
      <S.Video>
        <video muted autoPlay loop playsInline>
          <source
            src="https://player.vimeo.com/external/604238877.hd.mp4?s=106e63279e96ee33d0ca10dc6e6ad3b533dee4af&profile_id=174"
            type="video/mp4"
          />
        </video>
      </S.Video>
    </S.Container>
  );
};
